import React, {FC, memo} from 'react'
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import classnames from 'classnames'
import './SingleComment2.css'

dayjs.extend(relativeTime);

const SingleComment2Component: FC<{
    createdAt: number,
    message: string,
    reply: boolean,
    picture: string,
    name: string,
    type: string,
    showCreatedAt?: boolean,
}> = ({
    createdAt,
    message,
    reply,
    picture,
    name,
    type,
    showCreatedAt = true,
}) => {
    const messageTime = dayjs.unix(createdAt)
    const messageTimeFormatted = dayjs.unix(createdAt).format('H:mm')
    let now = dayjs()
    const timeDiff = now.diff(messageTime, 'day')
    let days = dayjs.unix(createdAt).fromNow()
    return (
        <div className={classnames("single-comment-2-comment-wrapper", { 'kudos': type === 'Kudos', 'is-reply': reply })}>
            <div className="single-comment-2-comment-avatar-container">
                <img className="single-comment-2-comment-avatar" src={picture} alt="avatar" />
            </div>
            <div className={classnames("single-comment-2-chat-message", { 'is-reply': reply })} >
                <div className="single-comment-2-comment-top-section">
                    <span className="single-comment-2-comment-name">{name}</span>
                    { showCreatedAt && (
                      <span className="single-comment-2-comment-created">{timeDiff < 1 ? messageTimeFormatted : days}</span>
                    )}
                </div>
                <div className="single-comment-2-comment-body">
                    { message && (
                      <span>{message}</span>
                    )}
                </div>

            </div>
            <div className="single-comment-2-comment-reaction"></div>
        </div>
    )
}

export const SingleComment2 = memo(SingleComment2Component)